/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowPhotographyExhibitionTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowPhotographyExhibition,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Capture and Showcase!",
    "Photography Exhibition Awaits!",
    "Let’s Exhibit Our Work!",
  ],
  title: "Photography Exhibition",
  description: "Organize a captivating photography exhibition.",
  longDescription:
    "Gather your friends for a photography exhibition! Choose a date, decide on themes, and plan activities for the event!",
  emoji: "📸",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Photography Exhibition",
          emoji: "📸",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the photography exhibition?",
          emoji: "📅",
          completeAction: {
            question: "Decide on themes for the exhibition?",
            description:
              "What themes should we showcase during the exhibition?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What themes should we consider?",
                emoji: "🌅",
                completeAction: {
                  question: "Decide on activities for the exhibition?",
                  description:
                    "What activities should we include during the exhibition?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What activities should we plan?",
                      emoji: "🎉",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Showcase Our Talents!",
    outroDescription:
      "Your photography exhibition plans are set! Enjoy the creativity!",
  },
};
